import React, { useEffect, useState } from 'react';
import './style.css'
import Time from '../Time';
import api from '../../services/api';
import { NiveisAcesso } from '../../constants/niveisAcesso';
import useDriver from '../../hooks/useDriver';
import { useLocation } from 'react-router-dom';

const TimerButton = () => {
    const [freeTrial, setFreeTrial] = useState(false);
    const [nivelAcesso, setNivelAcesso] = useState(0);
    const [userId, setUserId] = useState(0);
    const location = useLocation();
    const { pgrExterno } = useDriver(location.pathname);

    const fetchData = async () => {
        try {
            const { data: user } = await api.get('dados-usuario');
            if (user.nome === "Administrador") {
                setUserId(1);
                setNivelAcesso(4);
            } else {
                setUserId(user.id);
                const nivelAcesso = await api.get('nivel-acesso');
                setNivelAcesso(nivelAcesso.data.nivel);
            }
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
        }
    };
    useEffect(() => {
        fetchData();
        handleSearchPlan();
    }, []);

    const handleSearchPlan = async () => {
        const response = await api.post('buscar-free-trial');
        setFreeTrial(response.data);
    }

    return (
        <>
            {nivelAcesso === NiveisAcesso.CLIENTE && (

                <div id={!pgrExterno ? 'pgrStep1' : ''} className="timer-button">
                    {freeTrial == true ? (
                        <p style={{ fontSize: '13px', margin: 0, marginBottom: '5px' }}><b>Tempo de teste gratuito</b></p>
                    ) : (
                        <p style={{ fontSize: '13px', margin: 0, marginBottom: '5px' }}><b>Tempo para a conclusão do documento</b></p>
                    )}
                    <Time />
                </div>
            )}
        </>
    );
};

export default TimerButton;
